import React from "react";
import "../../styles/hero.css";

import heroDarkImg from "../../images/hero-img.png";
import lightImg from "../../images/light-hero-bg.jpg";

const Hero = ({ theme }) => {
  const handleGetStartedClick = () => {
    document.getElementById("contact").scrollIntoView({ behavior: "smooth" });
  };

  const handleDiscoverMoreClick = () => {
    document.getElementById("about").scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="hero__section" id="home">
      <div className="container">
        <div className="hero__wrapper">
          <div className="hero__content">
            <div>
              <h2>Empowering Your Brand</h2>
              <h2>With Effective Digital</h2>
              <h2 className="highlight">Marketing Solutions</h2>
            </div>
            <p className="description">
              At Mass Trading, we specialize in crafting customized marketing strategies that captivate your audience and deliver measurable results. Let’s collaborate to turn your vision into success.
            </p>

            <div className="hero__btns">
              <button className="primary__btn" onClick={handleGetStartedClick}>
                Start Your Journey
              </button>
              <button className="secondary__btn" onClick={handleDiscoverMoreClick}>
                Learn More
              </button>
            </div>
          </div>

          <div className="hero__img">
            <img
              src={theme === "light-theme" ? lightImg : heroDarkImg}
              alt="hero-img"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
